import { formatDistance } from "date-fns";
import { Clock, SquarePen, X } from "lucide-react";
import { useTranslation } from "react-i18next";

import type { ConversationSummary } from "../types";

import { Button } from "@/components/ui/v2/button";

export function CaptainSidebar({
  conversations,
  activeConversationId,
  onSelectConversation,
  onNewChat,
  onClose,
}: {
  conversations: ConversationSummary[];
  activeConversationId: string | null;
  onSelectConversation: (id: string) => void;
  onNewChat: () => void;
  onClose: () => void;
}) {
  const { t } = useTranslation();

  return (
    <div className="flex h-full flex-col border-r border-border bg-background-alt shadow-xl">
      <div className="flex items-center gap-3 border-b border-border px-4 py-3">
        <Button variant="ghost" size="icon-sm" onClick={onClose}>
          <X className="size-4" />
        </Button>
        <p className="flex-1 text-sm font-semibold">{t("captain.chatTitle")}</p>
        <Button variant="ghost" size="icon-sm" onClick={onNewChat}>
          <SquarePen className="size-4" />
        </Button>
      </div>

      <div className="flex items-center gap-2 px-4 py-2 text-xs font-medium text-muted-foreground">
        <Clock className="size-3.5" />
        {t("captain.recentChats")}
      </div>

      <div className="flex-1 overflow-y-auto">
        {conversations.map((conv) => (
          <button
            key={conv.id}
            onClick={() => onSelectConversation(conv.id)}
            className={`flex w-full items-center justify-between px-4 py-2.5 text-left text-sm transition-colors hover:bg-muted/50 ${
              conv.id === activeConversationId ? "bg-muted/30" : ""
            }`}
          >
            <span className="min-w-0 truncate">
              {conv.title ?? "New conversation"}
            </span>
            <span className="shrink-0 pl-2 text-xs text-muted-foreground">
              {formatDistance(new Date(conv.createdAt), new Date(), { addSuffix: true })}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
